module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('brand.label'),
      "columns": 6
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brands,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Buscar Marca"
    },
    model: {
      value: (_vm.filters.brand),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brand", $$v)
      },
      expression: "filters.brand"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('department.label'),
      "columns": 6
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.departments,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Buscar Categorias"
    },
    model: {
      value: (_vm.filters.department),
      callback: function($$v) {
        _vm.$set(_vm.filters, "department", $$v)
      },
      expression: "filters.department"
    }
  })], 1), _vm._v(" "), _c('product-status', {
    attrs: {
      "module": _vm.module
    },
    on: {
      "change": _vm.onChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6445d3dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/batch/reprocessProduct/filters/marketplace/Polishop.vue
// module id = 3233
// module chunks = 0